import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const tileStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 6,
  width: 84,
  padding: "12px 4px",
  borderRadius: 12,
  background: "#f5f5f5",
  cursor: "pointer",
  transition: "background 0.15s ease",
};

const iconStyle = {
  fontSize: 20,
  color: "#3E4A56",
};

const labelStyle = {
  fontSize: "0.68rem",
  lineHeight: 1.2,
  color: "#555",
  textAlign: "center",
};

const ProductActionMenuModal = ({ open, onClose, actions }) => {
  return (
    <Modal isOpen={open} toggle={onClose} className="modal-dialog-centered" size="sm">
      <ModalHeader toggle={onClose} tag="div">
        <div>Product Actions</div>
      </ModalHeader>
      <ModalBody>
        <div className="d-flex flex-wrap" style={{ gap: 10 }}>
          {(actions || []).map((action, i) => (
            <div
              key={i}
              style={tileStyle}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#ebebeb")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "#f5f5f5")}
              onClick={() => {
                action.onClick();
                onClose();
              }}
            >
              <i className={action.icon} style={iconStyle}></i>
              <span style={labelStyle}>{action.label}</span>
            </div>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ProductActionMenuModal;
